module.exports = __webpack_public_path__ + "img/kate_macK210917.700d498a.jpg";